import ons from "onsenui";
import React from "react";
import {
  TrainingCenterBundleItem,
  TrainingCenterCaregiverBundle,
} from "../../system/AppState/AppStateTrainingCenter";
import {
  setStatusBarAsBlackOnWhite,
  setStatusBarAsOverlayWhite,
  setStatusBarTranslucent as setStatusBarWhiteOnBlack,
} from "../../utils/statusBar";
import PanDown from "../PanDown";
import ScaffoldTitle from "../Scaffold/components/ScaffoldTitle";
import Scaffold from "../Scaffold/Scaffold";
import { TrainingCenterLanguagePreference } from "../TrainingCenter/TrainingCenterLanguageLookup";
import {
  getDisplayData,
  isTrainingCenterBundleCompleted,
} from "../TrainingCenter/TrainingCenterUtils";
import TrainingCenterBundleCertificate from "./components/TrainingCenterBundleCertificate";
import TrainingCenterBundleHeader from "./components/TrainingCenterBundleHeader";
import TrainingCenterBundleItemsList from "./components/TrainingCenterBundleItemsList";

interface Props {
  bundle: TrainingCenterCaregiverBundle;
  languagePreference: TrainingCenterLanguagePreference;
  canSocialShare: boolean;
  onClickShareCertificate: (bundle: TrainingCenterCaregiverBundle) => void;
  onClickOpenCertificate: (bundle: TrainingCenterCaregiverBundle) => void;
  onClickBundleItem: (
    bundleItem: TrainingCenterBundleItem,
    bundle: TrainingCenterCaregiverBundle
  ) => void;
  onClickPlayBundle: (bundle: TrainingCenterCaregiverBundle) => void;
  onClickGoBack: () => void;
  onDragDown: () => void;
}

const TrainingCenterBundleScreen = (props: Props) => {
  const isCompleted = isTrainingCenterBundleCompleted(props.bundle);
  const displayData = getDisplayData(props.bundle.bundleDisplayData, props.languagePreference);

  const onClickShareCertificate = () => props.onClickShareCertificate(props.bundle);
  const onClickOpenCertificate = () => props.onClickOpenCertificate(props.bundle);
  const onClickPlayBundle = () => props.onClickPlayBundle(props.bundle);
  const onClickBundleItem = (bundleItem: TrainingCenterBundleItem) => {
    return props.onClickBundleItem(bundleItem, props.bundle);
  };

  React.useEffect(() => {
    if (ons.platform.isIOS()) {
      setStatusBarAsOverlayWhite();
    }

    if (ons.platform.isAndroid()) {
      setStatusBarWhiteOnBlack();
    }

    return () => setStatusBarAsBlackOnWhite();
  }, []);

  return (
    <PanDown onDragDown={props.onDragDown}>
      <Scaffold
        className="TrainingCenterBundleScreen"
        title={<ScaffoldTitle label={displayData.data.title} />}
        theme="dark"
        overlayHeader={true}
        onClickGoBack={props.onClickGoBack}
      >
        <TrainingCenterBundleHeader
          bundle={props.bundle}
          languagePreference={props.languagePreference}
          onClickPlayBundle={onClickPlayBundle}
          className="lever"
          showOnboardingMessage={false}
        />

        <TrainingCenterBundleCertificate
          isOpen={isCompleted}
          canShare={props.canSocialShare}
          onClickShare={onClickShareCertificate}
          onClickOpen={onClickOpenCertificate}
        />

        <TrainingCenterBundleItemsList
          bundle={props.bundle}
          languagePreference={props.languagePreference}
          onClickBundleItem={onClickBundleItem}
        />
      </Scaffold>
    </PanDown>
  );
};

export default TrainingCenterBundleScreen;
